import React, { useState } from 'react';
import { Calendar, Trash2, Edit2, Gift } from 'lucide-react';
import { SpecialDate } from '../types';
interface SpecialDateItemProps {
  date: SpecialDate;
  onDelete: (id: string) => void;
}
export function SpecialDateItem({
  date,
  onDelete
}: SpecialDateItemProps) {
  const [isRevealed, setIsRevealed] = useState(false);
  const typeIcons = {
    birthday: Gift,
    anniversary: Calendar,
    holiday: Calendar,
    other: Calendar
  };
  const Icon = typeIcons[date.type];
  return <div className="relative overflow-hidden rounded-xl mb-3 group" data-id="element-698">
      {/* Actions Background */}
      <div className="absolute inset-0 flex items-center justify-end bg-red-50 pr-4 gap-2" data-id="element-699">
        <button onClick={() => onDelete(date.id)} className="p-2 bg-red-100 text-red-600 rounded-lg" data-id="element-700">
          <Trash2 size={18} data-id="element-701" />
        </button>
      </div>

      {/* Foreground Content */}
      <div className={`
          relative bg-white p-4 flex items-center gap-4 transition-transform duration-300 ease-out border border-gray-100 rounded-xl
          ${isRevealed ? '-translate-x-24' : 'translate-x-0'}
        `} onClick={() => setIsRevealed(!isRevealed)} data-id="element-702">
        <div className="w-10 h-10 rounded-full bg-purple-50 flex items-center justify-center text-purple-600 flex-shrink-0" data-id="element-703">
          <Icon size={20} data-id="element-704" />
        </div>
        <div className="flex-1" data-id="element-705">
          <h4 className="font-bold text-gray-900" data-id="element-706">{date.name}</h4>
          <p className="text-sm text-gray-500" data-id="element-707">
            {date.date} • {date.type}
          </p>
        </div>
        <div className="w-1 h-8 bg-gray-100 rounded-full" data-id="element-708" />
      </div>
    </div>;
}